export default "__VITE_ASSET__33653ebe__"